module.exports = __webpack_public_path__ + "img/joel-make-time.e69671d7.png";